import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';

const S3Plugin = React.lazy(() => importFromS3('tcc-operation-hub'));
const MFPlugin = React.lazy(() => import('operationHub/OperationHub'));

export const OperationHubPluginContainer: React.FC = () => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.operationHub.module-federation'];

  const OperationHubPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <OperationHubPlugin />;
};
